import { E as Environment } from "./environment-BHIxEh0R.js";
import { getEnvironment } from "../Environment.js";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import { l as loggerUtils } from "./loggerUtils-CebMqdva.js";
import { g as getLaunchDarklyUserKeyCookieValue } from "./useLaunchDarklyUpdater-qS2r1zS0.js";
import { jsx } from "react/jsx-runtime";
import { Provider } from "launchdarkly-react-client-sdk/lib/context";
function getLaunchDarklyClientId(env) {
  switch (env) {
    case Environment.STAGING:
    case Environment.TESTING:
    case Environment.EPHEMERAL:
      return process.env.REACT_APP_LAUNCHDARKLY_CLIENTID_STAGING || "missing-REACT_APP_LAUNCHDARKLY_CLIENTID_STAGING-see-code-comment";
    case Environment.PRODUCTION:
      return process.env.REACT_APP_LAUNCHDARKLY_CLIENTID_PRODUCTION || "missing-REACT_APP_LAUNCHDARKLY_CLIENTID_PRODUCTION-see-code-comment";
    case Environment.LOCAL:
      return "fake-client-id-for-Environment.LOCAL-see-code-comment";
    case Environment.UNKNOWN:
    default:
      return "fake-client-id-for-Environment.UNKNOWN-see-code-comment";
  }
}
class FakeLaunchDarklyClient {
  flags = {};
  user;
  constructor(flags, ldUser) {
    this.flags = flags;
    this.user = ldUser;
  }
  // eslint-disable-next-line class-methods-use-this
  waitUntilGoalsReady() {
    return Promise.resolve();
  }
  // eslint-disable-next-line class-methods-use-this
  waitUntilReady() {
    return Promise.resolve();
  }
  // eslint-disable-next-line class-methods-use-this
  waitForInitialization() {
    return Promise.resolve();
  }
  identify(user, _hash, onDone) {
    this.user = user;
    if (onDone) {
      onDone(null, this.flags);
    }
    return Promise.resolve(this.flags);
  }
  getUser() {
    return this.user;
  }
  // eslint-disable-next-line class-methods-use-this
  flush(onDone) {
    onDone?.();
    return Promise.resolve();
  }
  variation(key, defaultValue) {
    return this.flags[key] || defaultValue;
  }
  variationDetail(key, defaultValue) {
    const reason = {
      kind: "FALLTHROUGH"
    };
    const detail = {
      value: this.flags[key] || defaultValue,
      variationIndex: 0,
      reason
    };
    return detail;
  }
  // eslint-disable-next-line class-methods-use-this
  setStreaming() {
  }
  // eslint-disable-next-line class-methods-use-this
  on() {
  }
  // eslint-disable-next-line class-methods-use-this
  off() {
  }
  // eslint-disable-next-line class-methods-use-this
  track() {
  }
  // eslint-disable-next-line class-methods-use-this
  alias() {
  }
  allFlags() {
    return this.flags;
  }
  // eslint-disable-next-line class-methods-use-this
  close(onDone) {
    onDone?.();
    return Promise.resolve();
  }
}
const FakeLaunchDarklyFlagContextProvider = (props) => {
  const { flags = {}, user = { key: "fake-ld-flag-provider-user" }, children } = props;
  const fakeLdContext = {
    flags,
    flagKeyMap: {},
    ldClient: new FakeLaunchDarklyClient(flags, user)
  };
  return /* @__PURE__ */ jsx(Provider, { value: fakeLdContext, children });
};
async function FakeLaunchDarklyProviderHoc() {
  const clientSideFlags = await fetch(
    process.env.REACT_APP_CLIENT_SIDE_FLAGS_API_FOR_LOCAL_DEV ?? "/api/v1/testing/client_side_flags"
  ).then((response) => {
    if (!response.ok) {
      throw new Error(
        `Non-200 error code returned when fetching /api/v1/testing/client_side_flags for LaunchDarkly local dev set up. Was ${response.status}`
      );
    }
    const contentType = response.headers.get("content-type");
    const isJson = contentType?.includes("application/json");
    if (!isJson) {
      throw new Error(
        `Non-JSON response returned when fetching /api/v1/testing/client_side_flags for LaunchDarkly local dev set up. Has Content-Type '${contentType}'`
      );
    }
    return response.json();
  });
  const userKey = getLaunchDarklyUserKeyCookieValue();
  const user = userKey ? { key: userKey } : { key: "missing-ld-user-key-but-maybe-okay-for-now" };
  const flags = clientSideFlags.flag_data;
  const FakeLdFlagContextProvider = ({ children }) => /* @__PURE__ */ jsx(FakeLaunchDarklyFlagContextProvider, { flags, user, children });
  return Promise.resolve(FakeLdFlagContextProvider);
}
const logToConsole = (message) => loggerUtils.logMessageToConsole(`[Launch Darkly] ${message}`);
const ldLogger = {
  debug: () => null,
  // Don't log debug messages in staging/prod
  info: logToConsole,
  warn: logToConsole,
  error: (message) => {
    if (message && message.includes("network error")) {
      logToConsole(message);
    } else {
      loggerUtils.logException(new Error(`[Launch Darkly] ${message}`));
    }
  }
};
async function RealLaunchDarklyProviderHoc(clientId) {
  const userKey = getLaunchDarklyUserKeyCookieValue();
  const user = userKey ? { key: userKey } : { anonymous: true };
  const config = {
    user,
    clientSideID: clientId,
    reactOptions: {
      useCamelCaseFlagKeys: false
    },
    options: {
      logger: ldLogger
    }
  };
  return asyncWithLDProvider(config);
}
async function FeatureFlagProviderHoc() {
  const env = getEnvironment();
  switch (env) {
    case Environment.PRODUCTION:
    case Environment.STAGING:
    case Environment.EPHEMERAL:
    case Environment.TESTING:
      return RealLaunchDarklyProviderHoc(getLaunchDarklyClientId(env));
    case Environment.LOCAL:
    case Environment.UNKNOWN:
    default:
      if (process.env.REACT_APP_LAUNCHDARKLY_FORCE_LOCAL_REQUESTS_TO_CLIENT_ID != null) {
        return RealLaunchDarklyProviderHoc(
          process.env.REACT_APP_LAUNCHDARKLY_FORCE_LOCAL_REQUESTS_TO_CLIENT_ID
        );
      }
      return FakeLaunchDarklyProviderHoc();
  }
}
export {
  FakeLaunchDarklyFlagContextProvider as F,
  FeatureFlagProviderHoc as a
};
//# sourceMappingURL=FeatureFlagProvider-BJpU-nRw.js.map
